module.exports = __webpack_public_path__ + "static/media/400034_01.3c12b5bf.png";